import React from 'react';
import Icon from '../../../components/AppIcon';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Marie Dubois',
      role: 'Particulier - Paris 15e',
      rating: 5,
      comment: 'Intervention rapide et efficace pour une fuite d\'urgence. Le technicien était professionnel et a tout expliqué clairement. Je recommande vivement !',
      service: 'Réparation d\'urgence'
    },
    {
      name: 'Jean Martin',
      role: 'Copropriété - Boulogne',
      rating: 5,
      comment: 'Excellent service pour l\'installation de notre nouveau système de chauffage. Travail soigné, respect des délais et prix transparent.',
      service: 'Installation'
    },
    {
      name: 'Sophie Laurent',
      role: 'Commerce - Neuilly',
      rating: 5,
      comment: 'Le contrat de maintenance nous a évité plusieurs pannes coûteuses. L\'équipe est réactive et les rappels automatiques sont très pratiques.',
      service: 'Maintenance'
    }
  ];

  return (
    <section className="marketing-section">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-12">
          <p className="marketing-kicker mb-4">Avis clients</p>
          <h2 className="marketing-title text-3xl lg:text-5xl font-heading font-bold mb-4">
            Ce que disent <span className="marketing-accent">nos clients</span>
          </h2>
          <p className="marketing-muted text-lg">
            Plus de 2,500 clients satisfaits nous font confiance
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials?.map((testimonial, index) => (
            <div 
              key={index}
              className="marketing-card p-6"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial?.rating)]?.map((_, i) => (
                  <Icon key={i} name="Star" size={18} style={{ color: "#eab308", fill: "#eab308" }} />
                ))}
              </div>
              
              <p className="marketing-muted mb-4 leading-relaxed">
                "{testimonial?.comment}"
              </p>
              
              <div className="flex items-center justify-between pt-4 border-t border-cyan-300/10">
                <div>
                  <div className="font-semibold text-white">{testimonial?.name}</div>
                  <div className="marketing-muted text-sm">{testimonial?.role}</div>
                </div>
                <div className="text-right">
                  <div className="marketing-accent text-xs font-medium">{testimonial?.service}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;